import { render, staticRenderFns } from "./My_Gift.vue?vue&type=template&id=4243bb5e&scoped=true"
import script from "./My_Gift.vue?vue&type=script&lang=js"
export * from "./My_Gift.vue?vue&type=script&lang=js"
import style0 from "./My_Gift.vue?vue&type=style&index=0&id=4243bb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4243bb5e",
  null
  
)

export default component.exports